import { Building2, Check, MessageCircle, ArrowUpRight } from "lucide-react";
import { Logo } from "@/components/ui/Logo";

export function AuthBrandScene() {
  return (
    <div className="auth-brand-scene">
      <p className="auth-eyebrow">YOUR PROPERTIES. YOUR PEACE OF MIND.</p>
      <h2>
        A more connected
        <br />
        <span>way to manage.</span>
      </h2>
      <p>
        From the first conversation to the next renewal.
        <br />
        Your property world, together with Hazel.
      </p>
      <div
        className="auth-product-scene"
        aria-label="Illustrative connected property records"
      >
        <div className="auth-property-sheet">
          <div>
            <Logo variant="A" className="w-24" />
            <span>YOUR WORKSPACE</span>
          </div>
          <span className="auth-sheet-icon">
            <Building2 size={28} strokeWidth={1.3} />
          </span>
          <h3>Everything in its place.</h3>
          <p>One connected property record.</p>
          {[
            "Property & tenancy details",
            "Rent records & receipts",
            "Maintenance & documents",
          ].map((item) => (
            <div className="auth-record-row" key={item}>
              <span>{item}</span>
              <Check size={15} />
            </div>
          ))}
          <div className="auth-sheet-footer">
            From move-in to renewal <ArrowUpRight size={14} />
          </div>
        </div>
        <div className="auth-hazel-note">
          <span>
            <MessageCircle size={20} strokeWidth={1.5} />
          </span>
          <div>
            <strong>Connected to Hazel</strong>
            <p>Your AI property manager, on WhatsApp.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
